module.exports = __webpack_public_path__ + "img/jc.3ebf0ba8.png";